import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { Chip } from '@material-ui/core';

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 60,
    right: 'calc(50% + 8px)',
    left: 'calc(-50% + 18px)',
  },
  active: {
    '& $line': {
      backgroundColor: '#2EC179',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: '#2EC179',
    },
  },
  error: {
    '& $line': {
      backgroundColor: '#D9D9D9',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: 'transparent',
    zIndex: 1,
    color: '#fff',
    width: 5,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    color: '#2EC179',
  },
  completed: {
    color: '#2EC179',
  },
  error: {
    color: '#D9D9D9',
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed, error } = props;

  const icons = {
    active: <RadioButtonCheckedIcon />,
    completed: <CheckCircleIcon />,
    error: <HighlightOffIcon />,
    none: <RadioButtonUncheckedIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
        [classes.error]: error,
      })}>
      {icons[active ? 'active' : error ? 'error' : completed ? 'completed' : 'none']}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  stepper: {
    backgroundColor: 'transparent',
    padding: '14px 24px',
  },
  stepperLabel: {
    flexDirection: 'column-reverse !important',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['تبدیل', 'آپلود فایل'];
}

const actvieStatus = items => {
  let numberOfActiveState = 0;
  items.forEach(item => {
    const length = item.active_tapture_converts.length;
    if (length > 0) {
      numberOfActiveState += 1;
    }
  });
  return numberOfActiveState;
};

const deactiveStatus = items => {
  let numberOfDeactiveState = 0;
  const progress = {};
  items.forEach(item => {
    const length = item.deactive_tapture_converts.length;
    progress.status = item.deactive_tapture_converts.pop();
    if (length > 0) {
      numberOfDeactiveState += 1;
    }
  });
  return [progress?.status, numberOfDeactiveState];
};

export default function StepperConvert({ items, uploaded }) {
  const classes = useStyles();
  const steps = getSteps();

  const numberOfItems = items.length;

  const [progress, numberOfDeactiveState] = deactiveStatus(items);
  const numberOfactiveState = actvieStatus(items);

  return (
    <div className={classes.root}>
      <Stepper
        style={{ backgroundColor: 'none' }}
        alternativeLabel
        activeStep={uploaded ? 1 : 0}
        classes={{ root: classes.stepper }}
        connector={<ColorlibConnector />}>
        {steps.map((label, index) => {
          const stepProps = { active: false, completed: false, error: false };
          const labelProps = { active: false, completed: false, error: false };

          const totalActiveState = numberOfactiveState + numberOfDeactiveState;

          if (progress?.status === 'failed') {
            labelProps.error = true;
          }

          if (totalActiveState > 0) {
            labelProps.active = true;
          }
          if (index === 1 && uploaded) {
            labelProps.completed = true;
          } else if (index === 1) {
            labelProps.active = true;
          }

          if (progress?.status === 'processed') {
            stepProps.completed = true;
            labelProps.completed = true;
            labelProps.active = false;
          }

          return (
            <Step key={label} {...stepProps}>
              <StepLabel
                {...labelProps}
                classes={{ alternativeLabel: classes.stepperLabel }}
                StepIconComponent={ColorlibStepIcon}>
                {label}
              </StepLabel>
              {label === 'آپلود فایل' ? (
                <Chip style={{ marginLeft: 8 }} size={'small'} label={`${numberOfItems} | ${totalActiveState}`} />
              ) : null}
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
}
